import React, { useState, useEffect } from "react";
import { Button, ProgressBar } from "react-bootstrap";
import api from "../api0";

function LoyaltyPointsBanner() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchGamification = async () => {
      try {
        const res = await api.get("/gamification/status/", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        setData(res.data);
      } catch (err) {
        console.error("Failed to fetch gamification status", err);
      }
    };

    fetchGamification();
  }, []);

  if (!data) return null;

  return (
    <div className="p-4 rounded-4 text-white" style={{ background: "linear-gradient(90deg, #001F3F 0%, #003B73 100%)" }}>
      <h6 className="fw-bold mb-3">{data.tier} Member — {data.points} Self-Care Points</h6>
      <ProgressBar now={data.progress_to_next} variant="info" style={{ height: "10px" }} className="mb-1" />
      <p className="small font7">
        {data.progress_to_next < 100 ? `${data.progress_to_next}% to next tier` : "Tier upgrade available!"}
      </p>
      <Button variant="inherit" className="rounded-pill fw-bold col-12 badge-retarget">
        Redeem
      </Button>
    </div>
  );
}

export default LoyaltyPointsBanner;
